import React from "react";
import GoogleMapReact from "google-map-react";

// Same purple the old KML route style used (KML's aabbggrr FFD64A6B).
const ROUTE_COLOR = "#6B4AD6";
const DEFAULT_CENTER = { lat: 35.2271, lng: -80.8431 };

const isValidPoint = point =>
  !!point && Number.isFinite(point.lat) && Number.isFinite(point.lng);

/**
 * Draws a walk's GPS route as a line, with a marker at the home, and zooms to fit both.
 * `route` is a list of { lat, lng } points.
 */
export default class WalkRouteMap extends React.Component {
  drawRoute = ({ map, maps }) => {
    const { route = [], marker } = this.props;
    const bounds = new maps.LatLngBounds();

    if (route.length) {
      this.routeLine = new maps.Polyline({
        path: route,
        map,
        strokeColor: ROUTE_COLOR,
        strokeOpacity: 1,
        strokeWeight: 5
      });
      route.forEach(point => bounds.extend(point));
    }

    if (isValidPoint(marker)) {
      this.homeMarker = new maps.Marker({ position: marker, map });
      bounds.extend(marker);
    }

    if (!bounds.isEmpty()) map.fitBounds(bounds);
  };

  componentWillUnmount() {
    if (this.routeLine) this.routeLine.setMap(null);
    if (this.homeMarker) this.homeMarker.setMap(null);
  }

  render() {
    const { route = [], marker } = this.props;
    const center = route[0] || (isValidPoint(marker) ? marker : DEFAULT_CENTER);

    return (
      <div className="google-walk-map" style={{ height: "400px" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
          defaultCenter={center}
          defaultZoom={16}
          options={{ maxZoom: 18, scrollwheel: false }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={this.drawRoute}
        />
      </div>
    );
  }
}
